import {
  PROJECT_STATUS,
  PROJECT_PLAN,
  PROJECT_ROOM_TYPE,
  ADDITIONAL_HOURS_STATUS,
} from '../../constants/project';

export const isInProgressOrJustCompleted = status =>
  [PROJECT_STATUS.IN_PROGRESS, PROJECT_STATUS.SENT_TO_REVIEW, PROJECT_STATUS.APPROVED].includes(
    status,
  );

export const isAwaiting = status => status === PROJECT_STATUS.AWAITING;
export const isArchived = status => status === PROJECT_STATUS.ARCHIVED;
export const isOnboarding = status => status === PROJECT_STATUS.ONBOARDING;
export const isConsultancy = plan => plan === PROJECT_PLAN.CONSULTANCY;
export const isRoomStyling = roomType => roomType === PROJECT_ROOM_TYPE.ROOM_STYLING;
export const isDesignFix = roomType => roomType === PROJECT_ROOM_TYPE.DESIGN_FIX;
export const additionalHoursBought = additionalHours =>
  additionalHours === ADDITIONAL_HOURS_STATUS.APPROVED;



// WEBPACK FOOTER //
// ./app/javascript/common/components/ProjectStatus/utils.js